import { ButtonBase, Typography } from '@material-ui/core'
import SyncAltIcon from '@material-ui/icons/SyncAlt'
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat'
import React from 'react'

import { addCommaToPrice } from '../../helpers/numbers'
import { persianRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { WalletListItem } from '../../types/wallet'
import useStyles from './styles/WalletListTableDesktop.styles'

interface WalletListTableRowDesktopProps {
  data: WalletListItem
}

export const WalletListTableRowDesktop: React.FC<
  WalletListTableRowDesktopProps
> = ({ data }) => {
  const classes = useStyles()

  const isPersianSenderWallet = persianRegex.test(data.entity.entityName)

  return (
    <div className={[classes.tableRowRoot].join(' ')}>
      <ButtonBase
        data-cy="findNewAccommodation"
        className={classes.tableRow}
        component={LocalizedLink}
        to={`/adopay/wallet/${data.walletID}/details`}
        // disabled={!RoleAccessToViewAccommodationDeatils}
      >
        <div className={classes.nameCell}>
          <Typography
            variant="h4"
            style={
              isPersianSenderWallet ? { fontFamily: 'IranSans' } : undefined
            }>
            {data.entity.entityName}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate(data.entity.entityType)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate(data.currency || '')}
          </Typography>
        </div>
        <div className={classes.flex}>
          <span className={classes.iconWrapper}>
            {data.isBilateral ? <SyncAltIcon /> : <TrendingFlatIcon />}
          </span>
          <Typography variant="body1">
            {getTranslate(data.walletType)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {addCommaToPrice(data.walletBalance) +
              ` ${getTranslate(data.currency || '')}`}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {addCommaToPrice(data.remainingCreditBalance) +
              ` ${getTranslate(data.currency || '')}`}
          </Typography>
        </div>
        {data.active ? (
          <div>
            <Typography variant="body1" className={classes.active}>
              {getTranslate('Active')}
            </Typography>
          </div>
        ) : (
          <div>
            <Typography variant="body1" className={classes.deactive}>
              {getTranslate('Deactive')}
            </Typography>
          </div>
        )}
      </ButtonBase>
    </div>
  )
}
